import React, {useState, useEffect} from 'react';

//import '../components/Login.css';
import axios from 'axios';
import {TextField} from '@mui/material';
import '../css/Winners.css';
const Winners = () => {

    const [formData, setFormData] = useState({
        category: '',
        position: '',
        chest:'',
        name : '',
        school:'',
        location : '',
        //imgurl: null,
      });
    
      const [message, setMessage] = useState('');
      const [imagePreview, setImagePreview] = useState(null);
      //const navigate = useNavigate();
    // const handleChange = (e) => {
    //     setFormData({ ...formData, [e.target.name]: e.target.value });
    //   };

    const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };


   const handleImageChange = async (e) => {
  const file = e.target.files[0];  // Only the selected image
  const imagedata = new FormData();
  imagedata.append('file', file);   // Upload just the file
  imagedata.append('upload_preset', 'unsigned_upload'); // Preset needed by Cloudinary
  const res = await fetch('https://api.cloudinary.com/v1_1/dccuq6ut4/upload', {
    method: 'POST',
    body: imagedata,
  });

  const data = await res.json();
  console.log('Uploaded Image URL:', data.secure_url); // ← You can now use this URL
  setFormData(prev => ({
        ...prev,
        imgurl: data.secure_url
      }));
    
    const reader = new FileReader();
      reader.onload = (e) => {
        const preview = e.target.result;
        setImagePreview(preview);
        console.log('imagepreview', preview);
      };
      reader.readAsDataURL(file);
};

useEffect(() => {
  console.log("imagePreview changed:", imagePreview);
}, [imagePreview]);
  

  const handleReset = () => {
    setFormData({
      category: '',
      position: '',
      chest: '',
      name: '',
      school: '',
      location: '',
      //imgurl: null,
    });
    setImagePreview(null);
  };

    
      const handleSubmit = async (e) => {
        e.preventDefault();
       console.log('submit clicked');
        try {
          const res = await axios.post('/api/winnerslist', formData);
          console.log('formData', formData);
          //setMessage(res.data.message);
          if (res.status === 200 || res.status === 201) {
            
            // Redirect to dashboard
            //navigate('/dashboard');
           const user = res.data.newUser; // 👈 This is where user.email comes from
           console.log('user', user);
         
            
            //setMessage(`${formData.role.toUpperCase()} Program created successfully!`);
            
       
          }

        } catch (error) {
          console.log(error);
          if (error.res?.data?.error) {
            setMessage(error.res.data.error);
          } else {
            setMessage("Something went wrong");
          }
        }
        alert("Winners list added successfully");
      };
 
      return (
    <div className='wincontainer'>
      <div  className='winformCard'>
        <div className='winheader'>
          <h2 className='wintitle'>Add New Entry</h2>
          <p className='winsubtitle'>Fill in the details below to create a new record</p>
        </div>

        <form onSubmit={handleSubmit} className='winform'>
          <div className='wingrid'>
            <div className='wininputGroup'>
              <label className='winlabel'>
                Category <span className='winrequired'>*</span>
              </label>
              <input
                type="text"
                name="category"
                value={formData.category}
                onChange={handleChange}
                //style={styles.input}
                className='wininput'
                placeholder="Program Name"
                required
              />
            </div>

            <div className='wininputGroup'>
              <label className='winlabel'>
                Position <span className='winrequired'>*</span>
              </label>
              <input
                type="text"
                name="position"
                value={formData.position}
                onChange={handleChange}
                //style={styles.input}
                className='wininput'
                placeholder="Eg. First Prize"
                required
              />
            </div>

            <div className='wininputGroup'>
              <label className='winlabel'>
                Chest No. <span className='winrequired'>*</span>
              </label>
              <input
                type="text"
                name="chest"
                value={formData.chest}
                onChange={handleChange}
                //style={styles.input}
                className='wininput'
                placeholder="Eg. Chest No. 152"
                required
              />
            </div>

            <div className='wininputGroup'>
              <label className='winlabel'>
                Name <span className='winrequired'>*</span>
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                //style={styles.input}
                className='wininput'
                placeholder="Enter full name"
                required
              />
            </div>

            <div className='wininputGroup'>
              <label className='winlabel'>
                School <span className='winrequired'>*</span>
              </label>
              <input
                type="text"
                name="school"
                value={formData.school}
                onChange={handleChange}
                //style={styles.input}
                className='wininput'
                placeholder="Enter school name"
                required
              />
            </div>

            <div className='wininputGroup'>
              <label className='winlabel'>
                Location <span className='winrequired'>*</span>
              </label>
              <input
                type="text"
                name="location"
                value={formData.location}
                onChange={handleChange}
                //style={styles.input}
                className='wininput'
                placeholder="Enter location"
                required
              />
            </div>
          </div>

          {/* <div className='winimageSection'>
            <label className='winlabel'>
              Upload Image <span className='winrequired'>*</span>
            </label>
            
            <div className='winuploadArea'>
              {imagePreview ? (
                <div className='winpreviewContainer'>
                  <img src={imagePreview} alt="Preview" className='winpreview' />
                  <button
                    type="button"
                    onClick={() => {
                      setImagePreview(null);
                      setFormData(prev => ({ ...prev, image: null }));
                    }}
                    //style={styles.removeBtn}
                    className='winremoveBtn'
                  >
                     Remove
                  </button>
                </div>
              ) : (
                <label className='winuploadLabel'>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    //style={styles.fileInput}
                    className='winfileInput'
                  />
                  <div className='winuploadContent'>
                    <svg className='winuploadIcon' fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                    </svg>
                    <p className='winuploadText'>Click to upload or drag and drop</p>
                    <p className='winuploadHint'>PNG, JPG, GIF up to 10MB</p>
                  </div>
                </label>
              )}
            </div>
          </div> */}

          <div className='winbuttonGroup'>
            <button type="button" onClick={handleReset} className='winresetBtn'>
              Reset
            </button>
            <button type="submit" className='winsubmitBtn'>
              Submit Entry
            </button>
          </div>
        </form>
      </div>
    </div>
  );
  
};


// const styles = {
//   container: {
//     minHeight: '100vh',
//     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//     background: 'white',
//     padding: '20px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//   },
//   formCard: {
//     background: 'white',
//     borderRadius: '16px',
//     boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
//     maxWidth: '900px',
//     width: '100%',
//     overflow: 'hidden',
//   },
//   header: {
//     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//     padding: '20px',
//     color: 'white',
//     textAlign: 'center',
//   },
//   title: {
//     margin: '0 0 8px 0',
//     fontSize: '28px',
//     fontWeight: '700',
//   },
//   subtitle: {
//     margin: 0,
//     fontSize: '14px',
//     opacity: 0.9,
//   },
//   form: {
//     padding: '30px',
//   },
//   grid: {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
//     gap: '20px',
//     marginBottom: '30px',
//   },
//   inputGroup: {
//     display: 'flex',
//     flexDirection: 'column',
//   },
//   label: {
//     fontSize: '14px',
//     fontWeight: '600',
//     color: '#374151',
//     marginBottom: '8px',
//   },
//   required: {
//     color: '#ef4444',
//   },
//   input: {
//     padding: '12px 16px',
//     fontSize: '15px',
//     border: '2px solid #e5e7eb',
//     borderRadius: '8px',
//     outline: 'none',
//     transition: 'all 0.3s ease',
//     fontFamily: 'inherit',
//   },
//   imageSection: {
//     marginBottom: '30px',
//   },
//   uploadArea: {
//     marginTop: '8px',
//   },
//   uploadLabel: {
//     display: 'block',
//     border: '2px dashed #d1d5db',
//     borderRadius: '8px',
//     padding: '40px',
//     textAlign: 'center',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease',
//     background: '#f9fafb',
//   },
//   fileInput: {
//     display: 'none',
//   },
//   uploadContent: {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//   },
//   uploadIcon: {
//     width: '48px',
//     height: '48px',
//     color: '#9ca3af',
//     marginBottom: '12px',
//   },
//   uploadText: {
//     fontSize: '15px',
//     fontWeight: '500',
//     color: '#374151',
//     margin: '0 0 4px 0',
//   },
//   uploadHint: {
//     fontSize: '13px',
//     color: '#9ca3af',
//     margin: 0,
//   },
//   previewContainer: {
//     position: 'relative',
//     display: 'inline-block',
//   },
//   preview: {
//     maxWidth: '100%',
//     maxHeight: '300px',
//     borderRadius: '8px',
//     boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//   },
//   removeBtn: {
//     position: 'absolute',
//     top: '10px',
//     right: '10px',
//     background: '#ccc',
//     color: 'black',
//     border: 'none',
//     borderRadius: '6px',
//     padding: '6px 12px',
//     fontSize: '13px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//   },
//   buttonGroup: {
//     display: 'flex',
//     gap: '12px',
//     justifyContent: 'flex-end',
//   },
//   resetBtn: {
//     padding: '12px 32px',
//     fontSize: '15px',
//     fontWeight: '600',
//     border: '2px solid #e5e7eb',
//     borderRadius: '8px',
//     background: 'white',
//     color: '#374151',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease',
//   },
//   submitBtn: {
//     padding: '12px 32px',
//     fontSize: '15px',
//     fontWeight: '600',
//     border: 'none',
//     borderRadius: '8px',
//     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//     color: 'white',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease',
//     boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
//   },
// };

export default Winners;